import _ from 'lodash';
import AppDispatcher from '../AppDispatcher';
import WebApiUtils from '../WebApiUtils';
import ErrorHelper from '../web/ErrorHelper';

const DatatablesUtils = {
    getId(data) {
        return _.keys(data['data'])[0];
    },

    replaceId(url, id) {
        return _.replace(url, '_id_', id);
    },

    dispatchAsync(payload) {
        return new Promise(function (resolve) {
            function internalDispatchAsync(payload) {
                if (AppDispatcher.isDispatching()) {
                    setTimeout(function () {
                        internalDispatchAsync(payload);
                    }, 0);
                } else {
                    AppDispatcher.dispatch(payload);
                    resolve(true);
                }
            }

            internalDispatchAsync(payload);
        });
    },

    getCallbackForSuccess(successCallback, action) {
        return function (data) {
            return DatatablesUtils.dispatchAsync({
                type: action,
                data
            }).then(() => {
                successCallback(data);
            });
        };
    },

    getComplexCallbackForFail(successCallback, errorCallback, action) {
        return function (error) {
            return DatatablesUtils.dispatchAsync({
                type: action,
                error
            }).then(() => {
                if (error.errorDescription)
                    return successCallback({error: error.errorDescription});
                else
                    return errorCallback(error);
            });
        };
    },

    getSimpleCallbackForFail(action) {
        return function (error) {
            return DatatablesUtils.dispatchAsync({
                type: action,
                error
            });
        }
    },

    updateToken(token, callback) {
        WebApiUtils
            .updateTokenAsync(token)
            .then(newToken => {
                callback(newToken);
            });
    },

    getCallbackForCheckAndUpdateToken(token, returnCallback) {
        return function (error) {
            if (!ErrorHelper.isTokenExpired(error)) {
                return Promise.reject(error);
            }

            DatatablesUtils.updateToken(token, returnCallback);
        }
    },
};

export default DatatablesUtils;


// WEBPACK FOOTER //
// src/datatables/DatatablesUtils.js